// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"60":"6c80c99d","180":"87cc2f4e","297":"dc983c71","588":"41490674"}[chunkId] + ".js";
};